module.exports = __webpack_public_path__ + "static/img/1960_MusicForAmplifiedToyPianos_5.e08a1c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1960_MusicForAmplifiedToyPianos_5.jpg
// module id = IU9w
// module chunks = 0